<template>
	<svg viewBox="0 0 32 32">
		<path d="M16 0l-2.82 2.82 11.159 11.179h-24.34v3.999h24.34l-11.159 11.179 2.82 2.82 16-15.997z" />
	</svg>
</template>
